import { updateProfile, updateProfiles } from 'flow/actions/profile-actions';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { Profile } from 'flow/types/Profile';
import { TypedMap } from 'flow/types/TypedMap';
import { fromJS } from 'immutable';

const onUpdate = (
    extensionKey: ExtensionKey,
    profileKey: ProfileKey | 'profile',
    updateObject: {
        state: string[];
        value: string | boolean | Record<string, never> | number | object;
    }[],
    profiles?: List<TypedMap<Profile>>,
    profile?: TypedMap<Profile>,
) => {
    const updateFn = (
        profile?: TypedMap<Profile>,
        key?: ProfileKey | 'profile',
    ) => {
        let updatedProfile = profile || fromJS({ key: key || profileKey });

        updateObject.forEach(({ state, value }) => {
            updatedProfile = updatedProfile.setIn(state, value);
        });

        return updatedProfile;
    };

    if (profileKey === 'profile') {
        const updatedProfiles = profiles?.map((profile) => {
            if (profile.get('plusId') === 0) return profile;

            return updateFn(null, profile.get('key'));
        });
        return updateProfiles(extensionKey, updatedProfiles);
    }

    return updateProfile(extensionKey, updateFn(profile));
};

export default onUpdate;
